import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { plugin } from '@formkit/vue';
import SproutDesignSystem from 'design-system-next';
import App from './App.vue';
import router from './router';
import config from '../formkit.config';
import FloatingVue from 'floating-vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import { cioanalytics } from './services/analytics';

import 'design-system-next/style.css';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App);

app.config.globalProperties.$cioanalytics = cioanalytics;

app.use(router);
app.use(createPinia());
app.use(plugin, config);
app.use(SproutDesignSystem);
app.component('VueDatePicker', VueDatePicker);
app.use(FloatingVue, {
  themes: {
    'side-nav-tooltip': {
      $extend: 'tooltip',
      triggers: ['hover'],
      placement: 'right',
    },
    'default-tooltip': {
      $extend: 'tooltip',
      triggers: ['hover'],
    },
  },
});
app.mount('#app');
